<p>event-registration-redirect works!</p>
